import { Pipe, PipeTransform } from '@angular/core';

// "hack" JSON.stringify problem . 
export const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key: any, value: any) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

@Pipe({
  name: 'searchFilter',
  pure: false
})

export class SearchFilterPipe implements PipeTransform {
  transform(value: any[], args?: any): any {
     if(!value) return null;
     if(!args) return value;
     args = args.toLowerCase();
     let result = value.filter(function(item:any){
         return JSON.stringify(item, getCircularReplacer())
            .toLowerCase()
            .includes(args)
     })
     return result;
  }
}